;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sweetalert = require("sweetalert2");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      consumer_key: null,
      consumer_secret: null,
      invoice_id: null,
      tag: null
    };
  },

  mounted: function mounted() {
    this.consumer_secret = this.$attrs["con_secret"];
    this.consumer_key = this.$attrs["con_key"];
    this.invoice_id = this.$attrs["invoice_id"];
  },
  methods: {
    authorize_and_commit: function authorize_and_commit() {
      var _this = this;

      var url = "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this.submit(response.data.token);
      }).catch(function (error) {}).then(function () {});
    },
    submit: function submit(token) {
      if (this.tag == null || this.tag === "") {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Message",
          text: "Please specify a tag to continue"
        });
        return;
      }
      var urlIs = "/api/invoice/used/" + this.invoice_id;
      var api_headers = {
        Authorization: "Bearer " + token
      };

      var api_params = {
        id: this.invoice_id,
        tag: this.tag
      };

      Vue.axios.post(urlIs, api_params, {
        headers: api_headers
      }).then(function (response) {
        if (response.data.status == 422) {
          _sweetalert2.default.fire({
            icon: "error",
            title: "Oops...",
            text: "An error occurred during processing. If this persists, contact customer support for assistance"
          });
        } else {
          $("#addTagModal .close").click();
          _sweetalert2.default.fire({
            position: "top-end",
            icon: "success",
            title: "Invoice has been marked as used",
            showConfirmButton: false,
            timer: 2500
          });
          window.location.href = "/invoices";
        }
      }).catch(function (error) {
        _sweetalert2.default.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      }).then(function () {});
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn btn-outline-primary btn-sm",attrs:{"href":"javascript:void(0)","data-toggle":"modal","data-target":"#addTagModal"}},[_vm._v("Mark As Used")]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"addTagModal","tabindex":"-1","role":"dialog","aria-labelledby":"addTagModal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_c('form',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"overflow":"auto"}},[_c('div',{staticClass:"md-form mb-5"},[_c('label',{attrs:{"data-error":"wrong","data-success":"right"}},[_vm._v("Tag/Description")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tag),expression:"tag"}],staticClass:"form-control",attrs:{"type":"text","maxlength":"50","placeholder":"Enter tag or description","required":""},domProps:{"value":(_vm.tag)},on:{"input":function($event){if($event.target.composing){ return; }_vm.tag=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("\n              Close\n            ")]),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","value":"Submit"},on:{"click":_vm.authorize_and_commit}})])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Description/Tags")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1d6a3c5a", __vue__options__)
  } else {
    hotAPI.reload("data-v-1d6a3c5a", __vue__options__)
  }
})()}